<template>
  <div>
    <button class="consult-btn" @click="handleClick">
      <span class="btn-text">{{ text }}</span>
      <span class="btn-icon">
        <svg viewBox="0 0 40 40" fill="none" class="btn-svg">
          <circle cx="20" cy="20" r="20" fill="#fff" />
          <path d="M15 25L25 15" stroke="#E5AE21" class="btn-path" />
          <path d="M17.5 15H25V22.5" stroke="#E5AE21" class="btn-path" />
        </svg>
      </span>
    </button>
    <!-- 弹窗独立于按钮，兄弟节点 -->
    <div v-if="showQrModal" class="qr-modal-mask" @click.self="showQrModal = false">
      <div class="qr-modal-content">
        <img src="@/assets/images/close.png" alt="关闭" class="qr-modal-close" @click="showQrModal = false" />
        <img :src="require('@/assets/images/QR (1).png')" alt="WeChat QR" class="qr-modal-img" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConsultButtonMobile",
  props: {
    text: {
      type: String,
      default: "立即咨询"
    }
  },
  data() {
    return {
      showQrModal: false
    };
  },
  methods: {
    handleClick(e) {
      this.showQrModal = true;
      this.$emit("click", e);
    }
  }
};
</script>

<style scoped lang="scss">
// 按钮样式保持原样
.consult-btn {
  display: inline-flex;
  align-items: center;
  position: relative;
  color: #fff;
  border: none;
  border-radius: 100px;
  font-size: 18px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.2s;
  height: 48px;
  padding: 0 50px 0 24px;
  outline: none;
  box-sizing: border-box;
  white-space: nowrap;
  min-width: fit-content;
  background: #E5AE21;
}

.btn-text {
  display: block;
  text-align: left;
  white-space: nowrap;
  font-weight: 600;
  z-index: 1;
  margin-right: 8px;
}

.btn-icon {
  position: absolute;
  right: 5px;
  top: 4px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.btn-svg {
  width: 40px;
  height: 40px;
}

.btn-path {
  stroke-width: 2.5;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.consult-btn:hover {
  background: #E5AE21;
}

// 弹窗样式
.qr-modal-mask {
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-modal-content {
  background: #fff;
  border-radius: 40px;
  padding: 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.qr-modal-img {
  width: 267px;
  height: 361px;
  border-radius: 40px;
  object-fit: cover;
  display: block;
}

.qr-modal-close {
  position: absolute;
  top: -40px;
  right: -14px;
  width: 32px;
  height: 32px;
  cursor: pointer;
  z-index: 10;
}
</style>